import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { CompositeFilterDescriptor, filterBy, FilterDescriptor } from '@progress/kendo-data-query';
import { DropDownList, DropDownListChangeEvent, DropDownListFilterChangeEvent } from '@progress/kendo-react-dropdowns';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useCodeTableAttributesQuery } from '../hooks/useCodeTables';

export const AttributeCell = (props: any) => {
    let path = props?.forDocumentLink ? 'sourceDirectory' : 'targetFolder';
    let workspaceName =
        typeof props.dataItem?.[path] === 'object' ? props.dataItem?.[path]?.workspaceName : props.dataItem?.[path];

    const { data: customAttribute, isLoading } = useCodeTableAttributesQuery(
        workspaceName,
        props?.idCustomAttribute,
        props?.forDocumentLink,
    );

    const [data, setData] = useState<any>(customAttribute?.slice());

    const filterData = (filter: FilterDescriptor | CompositeFilterDescriptor) => {
        const data: any[] = customAttribute!.slice();
        return filterBy(data, filter);
    };

    const filterChange = (event: DropDownListFilterChangeEvent) => {
        setData(filterData(event.filter));
    };
    const handleChange = (e: DropDownListChangeEvent) => {
        if (props.onChange) {
            props.onChange({
                dataIndex: 0,
                dataItem: props.dataItem,
                field: props.field,
                syntheticEvent: e.syntheticEvent,
                value: e.target.value,
            });
        }
    };
    const { dataItem } = props;
    const field = props.field || '';
    const dataValue = dataItem[field];

    useEffect(() => {
        setData(customAttribute?.slice());
    }, [customAttribute]);

    const clear = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        handleChange({
            target: {
                value: null,
            },
        } as any);
    };

    return (
        <DropDownList
            {...props}
            data={data}
            onChange={handleChange}
            value={customAttribute?.find(
                (c: any) => c?.asiteCustomAttributeCode === dataValue?.asiteCustomAttributeCode,
            )}
            disabled={props.disabled || _.isEmpty(customAttribute)}
            onFilterChange={filterChange}
            filterable={props?.filterable ?? true}
            textField="asiteCustomAttributeName"
            dataItemKey="asiteCustomAttributeCode"
            loading={isLoading}
            style={{ fontSize: '12px' }}
            valueRender={(element, value) => {
                return (
                    <ValueRender
                        element={element}
                        value={value}
                        textField={props.textField}
                        hasDeleteOption={props.hasDeleteOption}
                        clear={(e: any) => clear(e)}
                    />
                );
            }}
        />
    );
};

export const ValueRender: React.FC<any> = ({ element, value, clear, hasDeleteOption }) => {
    if (!value) {
        return element;
    }

    const children = [
        <span key={2} style={{ overflow: 'hidden' }}>
            {element.props.children}
        </span>,
        hasDeleteOption && Object.keys(value).length > 0 ? (
            <IconButton aria-label="delete" onClick={clear} style={{ marginLeft: 'auto' }} size="small">
                <CloseIcon fontSize="small" />
            </IconButton>
        ) : null,
    ];

    return React.cloneElement(element, { ...element.props }, children);
};
